export type UnsplashResult = {
	altDescription: string;
	artistName: string;
	artistUrl: string;
	downloadLink: string;
	fullSizeImageUrl: string;
	id: string;
	smallSizeImageUrl: string;
};

export type SelectedImage = {
	altDescription: string;
	downloadLink?: string;
	fullSizeImageUrl: string;
};

export enum ThumbnailType {
	UNSPLASH_DEFAULT_IMAGE,
	UNSPLASH_IMAGE,
	CUSTOM_IMAGE,
	EXTERNAL_SITE_IMAGE,
	NO_IMAGE,
}

export type UnsplashImage = {
	altDescription?: string;
	fullSizeImageUrl: string;
};

export type UploadedImage = {
	altDescription: string;
	uploadedImageId: string;
};

export type CustomImage = {
	imageId: string;
};

export type Thumbnail = {
	image: UnsplashResult | UnsplashImage | CustomImage | string | undefined;
	type: ThumbnailType;
};

export type GenericUnsplashImage = {
	description: string;
	downloadLink?: string;
	fullSizeImageUrl: string;
	index: number;
	isSelected: boolean;
	smallSizeImageUrl: string;
};
